import { Property } from '../../types';

const getAccountNumber = (property: Property) => {
  if (property?.contacts) {
    if (property.contacts?.default) {
      return property.contacts.default.accountNumber;
    }

    if (property.contacts?.all) {
      return '';
    }
  }

  if (property?.agents?.length) {
    return property.agents[0].accountNumber;
  }

  if (property?.account) {
    return property.account.accountNumber;
  }

  return '';
};

export default getAccountNumber;
